const ID_TOKEN_KEY = "id_token";
import routeTenant, {getTenantCurrent} from "@/core/services/routeTenant.service";

export const getKeyToken = () => {
  let tenant = routeTenant.getTenantCurrent();
  if (tenant){
    return ID_TOKEN_KEY+'-'+tenant;
  }
  return ID_TOKEN_KEY;
};

export const getToken = () => {
  const tenant = routeTenant.getTenantCurrent();
  const keyToken = `${ID_TOKEN_KEY}_${tenant}`
  return window.localStorage.getItem(keyToken);
};

export const saveToken = token => {
  const tenant = routeTenant.getTenantCurrent();
  const keyToken = `${ID_TOKEN_KEY}_${tenant}`
  window.localStorage.setItem(keyToken, token);
};

export const destroyToken = () => {
  const tenant = routeTenant.getTenantCurrent();
  const keyToken = `${ID_TOKEN_KEY}_${tenant}`
  window.localStorage.removeItem(keyToken);
};

export default { getToken, saveToken, destroyToken };
